export const REPORT_CONTENT_ORDER_BY_POSTS = [
  'engagement_rate',
  'reach',
  'impressions',
  'likes',
  'comments',
  'shares',
  'video_views',
  'published_at_desc',
  'published_at_asc',
] as const;

export type ReportContentOrderByPosts =
  (typeof REPORT_CONTENT_ORDER_BY_POSTS)[number];

export const REPORT_CONTENT_POST_COUNTS = [
  '5',
  '10',
  '15',
  '30',
  'all',
] as const;

export type ReportContentPostCount =
  (typeof REPORT_CONTENT_POST_COUNTS)[number];

export const REPORT_CONTENT_POST_COUNT_NONE = 'none';

export function isReportContentPostsEnabled(contentDefaults: {
  content_post_count?: string | null;
}): boolean {
  return (
    contentDefaults.content_post_count != null &&
    contentDefaults.content_post_count !== REPORT_CONTENT_POST_COUNT_NONE
  );
}

export const REPORT_PREVIEW_ALL_POSTS_CAP = 30;
